import { Modal } from "antd";
import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Holidays } from "../../../redux/apis/types";
import DatePickerController from "../../../form/DatePickerController";
import dayjs, { Dayjs } from "dayjs";

export type Data = Omit<Holidays, "id">;

type Props = {
  visible: boolean;
  onSave: (date: Dayjs) => void;
  onClose: () => void;
};

const NewPaidInvoiceModal = (props: Props) => {
  const methods = useForm({
    defaultValues: {
      paid_date: dayjs(),
    },
  });

  const [loading, setLoading] = useState(false);

  const onSave = async (data: any) => {
    props.onSave(data.paid_date);
  };

  const { handleSubmit } = methods;

  return (
    <Modal
      title={"Paid Invoice"}
      visible={props.visible}
      confirmLoading={loading}
      onOk={handleSubmit(onSave)}
      onCancel={props.onClose}
      okText="Save"
      cancelText="Cancel"
    >
      <FormProvider {...methods}>
        <form
          onSubmit={handleSubmit(onSave)}
          style={{ rowGap: 10, display: "grid" }}
        >
          <DatePickerController
            rules={{ required: true }}
            name={`paid_date`}
            label="Date"
            style={{ width: "100%" }}
          />
        </form>
      </FormProvider>
    </Modal>
  );
};

export default NewPaidInvoiceModal;
